import { RouteIcon } from '#/shared/ui/icons'

interface LocationCellProps {
  origin: string
  destination: string
}

export function LocationCell({ origin, destination }: LocationCellProps) {
  return (
    <div className="flex items-center gap-2.5">
      <RouteIcon className="h-14 w-4 shrink-0" />
      <div className="flex min-w-0 flex-col items-start">
        <div className="flex h-7 max-w-full items-center">
          <span
            title={origin}
            className="max-w-72 truncate text-sm text-gray-900"
          >
            {origin || '-'}
          </span>
        </div>
        <div className="flex h-7 max-w-full items-center">
          <span
            title={destination}
            className="max-w-72 truncate text-sm text-gray-900"
          >
            {destination || '-'}
          </span>
        </div>
      </div>
    </div>
  )
}
